import { FilterId } from '../types/filters';

export const CURRENT_PREVIOUS_FILTER_CONFIG: Record<string, FilterId[]> = {
  '/talent-discovery': [
    FilterId.COMPANY,
    FilterId.FLIGHT_RISK,
    FilterId.GEOGRAPHY,
    FilterId.PRESTIGE,
    FilterId.REMOTE_SUITABILITY,
    FilterId.ROLE,
    FilterId.SENIORITY,
    FilterId.PAY,
    FilterId.TITLE,
  ],
};

export const shouldShowCurrentPreviousToggle = (
  filterId: FilterId,
  route: string
): boolean => {
  const filtersForRoute = CURRENT_PREVIOUS_FILTER_CONFIG[route];
  return filtersForRoute?.includes(filterId) ?? false;
};
